import { AfterContentInit, Component, EventEmitter, Input, input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IField } from '../../interfaces/Field';
import { MatButton, MatButtonModule } from "@angular/material/button";

@Component({
  selector: 'properties-table',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule
],
  templateUrl: './properties-table.component.html',
  styleUrl: './properties-table.component.scss'
})
export class PropertiesTableComponent{
  
  @Input() properties!: IField[];
  @Input() showOptions: boolean = true;
  @Output() onEvent: EventEmitter<{ field: IField, event: MouseEvent }> = new EventEmitter();
}
